// extracted by mini-css-extract-plugin
module.exports = {"languages":"LOC_languages__4xlUA","language":"LOC_language__fBg8U","languageName":"LOC_languageName__e-s6e","progress":"LOC_progress__1yD1Z","loc":"LOC_loc__Q4dn3"};